const defaultMessageError = 'Este campo es obligatorio';
const validator = {
    fechaCarga: {
        rules: [
            {
                test: (value) => {
                    return (typeof(value) !== 'undefined' && value !== null && value !== '');
                },
                message: defaultMessageError,
            },
        ],
        errors: [],
        valid: false,
        state: '',
        exclude: false
    }
};

export default validator;



// WEBPACK FOOTER //
// ./src/pages/modals/SeleccionarSituacion/validatorsPlantilla2.js